// FutureLab
import { ChatListDataInterface } from '../ChatListItemsMobile';

import { Paperclip } from 'lucide-react';
import _ from 'lodash';
import { richTextPreview } from '../ChatRichTextEditor';

interface ChatListItemUnreadCountProps {
	chatListItem: ChatListDataInterface;
}

export function ChatListItemUnreadCount(chatListItemUnreadCountProps: ChatListItemUnreadCountProps) {
	const { chatListItem } = chatListItemUnreadCountProps;
	const latestMessage = richTextPreview(chatListItem.latestMessage);

	return (
		<div className="flex min-w-0 items-center gap-2">
			<div className="min-w-0 flex-1 truncate text-sm text-slate-500">
					{!_.isEmpty(chatListItem?.latestAttachment?.[0]) && latestMessage !== '' ? (
						<>
							<Paperclip className="mb-0.5 inline size-4" />
							<span className="pl-1.5">{latestMessage}</span>
						</>
					) : (
						<>
							{!_.isEmpty(chatListItem?.latestAttachment?.[0]) ? (
								<>
								<Paperclip className="mb-0.5 inline size-4" />
									<span className="pl-1.5">Attachment</span>
								</>
							) : (
								<>{latestMessage}</>
							)}
						</>
					)}
			</div>
				{(chatListItem.unreadCount ?? 0) > 0 ? (
					<span className="inline-flex min-w-5 shrink-0 items-center justify-center rounded-full bg-primary px-1.5 py-0.5 text-xs font-medium text-primary-foreground">
						{chatListItem.unreadCount}
					</span>
				) : (
					''
				)}
		</div>
	);
}
